import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { hostList, delhost } from '@/api/liveData/liveData';
import addHost from './components/addHost.vue';
export default {
  name: "anchorManagement",
  components: {
    addHost: addHost
  },
  data: function data() {
    return {
      pageSize: 10,
      total: 0,
      list: [],
      params: {
        page: 1
      }
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;

      hostList(this.params).then(function (res) {
        if (res.status == 200) {
          _this.list = res.data;
        }
      });
    },
    handleCurrentChange: function handleCurrentChange(value) {
      this.params.page = value;
      this.getList();
    },
    handleDelete: function handleDelete(item) {
      var _this2 = this;

      this.$confirm("此操作将删除该支付类型, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                delhost({
                  id: item.id
                }).then(function (res) {
                  if (res.status == 200) {
                    _this2.getList();
                  }
                });

                _this2.$message({
                  type: "success",
                  message: "删除成功!"
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    }
  }
};